import { render, staticRenderFns } from "./SalesSparkline.vue?vue&type=template&id=65ff2b0c&scoped=true&"
import script from "./SalesSparkline.vue?vue&type=script&lang=js&"
export * from "./SalesSparkline.vue?vue&type=script&lang=js&"
import style0 from "./SalesSparkline.vue?vue&type=style&index=0&id=65ff2b0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff2b0c",
  null
  
)

export default component.exports